import { motion } from "framer-motion";
import groupedImage from "./assets/Integration-01-01 1.svg";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#FAFAFA] py-20 px-4 sm:px-6">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* Left Column – 60% with animation */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h5 className="text-[#07862B] text-sm font-semibold uppercase mb-3 tracking-wide">
            Third Party Integration
          </h5>

          <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
            Seamlessly supercharge <br className="hidden sm:block" /> your
            systems with powerful
          </h2>

          <p className="text-[#4A4A4A] text-gray-600 leading-relaxed max-w-[580px]">
            Third-party integration connects your s5ftware to external platforms
            to enhance functionality, streamline operations, and boost overall
            efficiency.
          </p>
        </motion.div>

        {/* Right Column – 40% with animation */}
        <motion.div
          className="w-full lg:w-[40%] flex justify-center"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <img
            src={groupedImage}
            alt="Third Party Illustration"
            className="w-454 max-w-[600px] h-auto object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
